import React, { useState, useEffect } from "react";
import { Field, Form, Formik } from "formik";
import * as yup from "yup";
import { MdClose } from "react-icons/md";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "../../../../HOC/CreateAxios/CreateAxios";
import Table from "../../../UI/Table/Table";
function AddService() {
  const Schema = yup.object().shape({
    service_name: yup.string().required("Service name is required"),
    price: yup.string().required("Price is required"),
    // service_unit: yup.string().required("Unit is required"),
    // service_quantity: yup.string().required("Quantity is required"),
  });
  const [storeImage, setStoreImage] = useState("");

  const [Tbody, setTbody] = useState([]);
  const thead = [
    { title: "s.nO", width: "10%" },
    { title: "name", width: "70%" },
    { title: "quantity", width: "10%" },
    { title: "unit", width: "10%" },
    { title: "action", width: "10%" },
  ];
  const getProduct = () => {
    axios
      .get("/product")
      .then((res) => {
        // console.log(res);
        setTbody(res.data.result);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    getProduct();
  }, []);
  let opt = [];
  Tbody?.map((val, i) => {
    let datas = {
      value: val.product_name,
      id: val.id,
      priceandunit: val.priceandunit,
    };
    return opt.push(datas);
  });
  const [multiSelecting, setMultiSelecting] = useState([]);

  const FormInitial = [
    {
      label: "Service Name",
      apiKey: "service_name",
      placeholder: "Enter Service name here !",
      type: "text",
    },

    {
      label: "products",
      apiKey: "products_category",
      placeholder: "Enter category name here !",
      type: "select",
      options: [{ value: "work", id: "work" }, ...opt],
    },
    {
      label: "Service price",
      apiKey: "price",
      placeholder: "Enter  price here !",
      type: "number",
    },
  ];
  const MultiSelect = (e) => {
    console.log(e.target.value);
    let index = Tbody.findIndex((x) => x.id === e.target.value);
    let data = e.target.value.split("/");
    Tbody[index].Squantity = 1;
    setMultiSelecting([...multiSelecting, Tbody[index]]);
  };
  const RemoveMultiSelecting = (id) => {
    console.log(id);
    let data = [...multiSelecting];
    data.splice(id, 1);
    setMultiSelecting(data);
  };

  const Submit = (value) => {
    let formData = new FormData();
    formData.append("image", value.image);
    formData.append("service_name", value.service_name);
    formData.append("price", value.price);

    multiSelecting?.map((val, i) => {
      console.log(val);
      return formData.append(
        "priceUnit[]",
        JSON.stringify({
          product_id: val.id,
          name: val.product_name,
          unit: val.Sunit,
          quantity: val.Squantity,
        })
      );
    });

    axios
      .post(`/service`, formData)
      .then((res) => {
        setMultiSelecting([]);
        toast.success("Service has been added sucessfully");
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const AddQuantity = (id) => {
    console.log(multiSelecting);
    let index = multiSelecting.findIndex((x) => x.id === id.id);
    console.log(index);
    if (index > -1) {
      multiSelecting[index].Squantity = multiSelecting[index].Squantity + 1;
      setMultiSelecting([...multiSelecting]);
    }
  };
  const SubtractQuantity = (id) => {
    console.log(multiSelecting);
    let index = multiSelecting.findIndex((x) => x.id === id.id);
    console.log(index);
    if (index > -1) {
      if (multiSelecting[index].Squantity > 1) {
        multiSelecting[index].Squantity = multiSelecting[index].Squantity - 1;
        setMultiSelecting([...multiSelecting]);
      }
    }
  };
  const HandleChange = (e) => {
    console.log(e.target.value);
  };

  return (
    <div className="p-6">
      {/* form is done here */}
      <div>
        <Formik
          initialValues={{
            service_name: "",
            image: "",
            priceUnit: "",
            price: "",
            products_category: "",
          }}
          validationSchema={Schema}
          onSubmit={(values, { resetForm }) => {
            console.log(values);
            Submit(values);
            resetForm();
          }}
        >
          {({ errors, handleSubmit, values, touched, setFieldValue }) => {
            return (
              <Form onSubmit={handleSubmit}>
                <div className="grid laptop:grid-cols-2 gap-8">
                  {FormInitial &&
                    FormInitial?.map((val, i) => {
                      if (val.type === "select") {
                        return (
                          <div
                            key={i}
                            className="flex flex-col space-y-2 relative"
                          >
                            <label className="px-1 poppins font-medium">
                              {val.label}
                            </label>
                            <Field
                              name={val.apiKey}
                              as={val.type}
                              placeholder={val.placeholder}
                              onChange={(e) => MultiSelect(e)}
                              className="border py-2 px-1 font-normal outline-none capitalize"
                            >
                              {val.options?.map((vals, i) => {
                                return (
                                  <option
                                    className="capitalize"
                                    key={i}
                                    value={
                                      vals.id
                                      // priceUnit
                                    }
                                  >
                                    {vals.value}
                                  </option>
                                );
                              })}
                            </Field>
                            <div
                              className={`${
                                multiSelecting.length > 0
                                  ? "bg-gray-200 w-full tablet:absolute top-[95px]  overflow-scroll h-80 "
                                  : ""
                              }`}
                            >
                              <div className=" w-full">
                                <div className="flex  flex-wrap gap-3 ">
                                  {multiSelecting?.length > 0 ? (
                                    <Table Head={thead} height="priceUnit">
                                      {multiSelecting?.map((item, i) => {
                                        return (
                                          <tr
                                            key={i}
                                            className="border-b relative  "
                                          >
                                            <td align="center">
                                              <div className=" p-2.5 border-gray-300">
                                                {i + 1}
                                              </div>
                                            </td>
                                            <td align="center">
                                              <div className=" p-2.5 border-gray-300">
                                                {item.product_name}
                                              </div>
                                            </td>
                                            <td align="center">
                                              <div className=" p-2.5 border-gray-300 flex items-center justify-center gap-3">
                                                <div
                                                  className="bg-gray-50 px-4 text-xl hover:scale-105 transition-all 
                                                ease-in-out duration-200 delay-75 cursor-pointer py-1"
                                                  onClick={() =>
                                                    SubtractQuantity(item)
                                                  }
                                                >
                                                  -
                                                </div>
                                                <div> {item.Squantity}</div>
                                                <div
                                                  className="bg-gray-50 px-4 text-xl hover:scale-105 transition-all 
                                                ease-in-out duration-200 delay-75 cursor-pointer py-1"
                                                  onClick={() =>
                                                    AddQuantity(item)
                                                  }
                                                >
                                                  +
                                                </div>
                                              </div>
                                            </td>
                                            <td align="center">
                                              <div className=" p-2.5 ">
                                                <select
                                                  className="bg-white px-6 py-2 border-none outline-none"
                                                  onChange={(e) =>
                                                    HandleChange(e)
                                                  }
                                                >
                                                  {item?.priceandunit?.map(
                                                    (val, i) => {
                                                      if (i === 0) {
                                                        item.Sunit = val.unit;
                                                      }
                                                      return (
                                                        <option key={i}>
                                                          {val.unit}
                                                        </option>
                                                      );
                                                    }
                                                  )}
                                                </select>
                                              </div>
                                            </td>

                                            <td>
                                              {" "}
                                              <div
                                                className="bg-red-500 text-white w-fit  mx-auto rounded-full flex justify-center items-center"
                                                onClick={() =>
                                                  RemoveMultiSelecting(i)
                                                }
                                              >
                                                {multiSelecting.length > 0 && (
                                                  <MdClose />
                                                )}
                                              </div>
                                            </td>
                                          </tr>
                                        );
                                      })}
                                    </Table>
                                  ) : (
                                    <></>
                                  )}
                                </div>
                              </div>
                            </div>
                            <div
                              className={`${
                                errors[val.apiKey] && touched[val.apiKey]
                                  ? " bg-red-50 w-full p-1 my-1 text-red-500 text-sm"
                                  : ""
                              }`}
                            >
                              {errors[val.apiKey] && touched[val.apiKey]
                                ? errors[val.apiKey]
                                : ""}
                            </div>
                          </div>
                        );
                      } else {
                        return (
                          <div key={i} className="flex flex-col space-y-2">
                            <label className="px-1 poppins font-medium">
                              {val.label}
                            </label>
                            <Field
                              name={val.apiKey}
                              type={val.type}
                              placeholder={val.placeholder}
                              className="border py-2 px-1 "
                            />
                            <div
                              className={`${
                                errors[val.apiKey] && touched[val.apiKey]
                                  ? " bg-red-50 w-full p-1 my-1 text-red-500 text-sm"
                                  : ""
                              }`}
                            >
                              {errors[val.apiKey] && touched[val.apiKey]
                                ? errors[val.apiKey]
                                : ""}
                            </div>
                          </div>
                        );
                      }
                    })}
                </div>
                {/* for image */}
                <div className="mt-4 w-6/12 flex flex-col">
                  <label htmlFor="image" className="poppins font-medium pb-2">
                    Service Image
                  </label>
                  <label
                    htmlFor="image"
                    className="poppins font-medium bg-GrayLight h-full w-full border"
                  >
                    <img
                      src={
                        values.image
                          ? URL.createObjectURL(values.image)
                          : "https://images.unsplash.com/photo-1660039031080-7779c1760a0c?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=870&q=80"
                      }
                      alt="image"
                      className="h-72 mx-auto cursor-pointer w-6/12"
                    />
                  </label>
                  <input
                    id={"image"}
                    name={"image"}
                    type="file"
                    accept=".gif,.jpg,.jpeg,.png,"
                    className="border-2 p-1 w-full outline-none mt-2"
                    onChange={(event) => {
                      let name = "image";
                      console.log("event.target", values[name]);
                      console.log(event.target.files[0]);
                      let value = event.target.files[0];
                      value === undefined
                        ? setFieldValue(name, values[name])
                        : setFieldValue(name, event.target.files[0]);
                    }}
                  />
                </div>
                <div className="w-full mt-6 ">
                  <button
                    type="submit"
                    className="px-8 py-2 bg-green-600 text-white rounded-sm shadow-md cursor-pointer"
                  >
                    Submit
                  </button>
                </div>
              </Form>
            );
          }}
        </Formik>
      </div>
    </div>
  );
}

export default AddService;
